// extracted by mini-css-extract-plugin
module.exports = {"root":"_56bfa8","isLoggedIn":"_4c5221","texts":"_cf5932","welcomeBackText":"_289df3","nameText":"_e3f8c0","userAvatar":"_415ffb","userIcon":"_051350"};